export const BUSINESS_UNIT = Object.freeze({
  BOT: 'BOT',
  QDB: 'QDB',
  GB: 'GB',
  GBPT: 'GBPT',
  VDBOT: 'VDBOT',
  BBX: 'BBX',
  BLZ: 'BLZ'
})
